<template>
  <v-card>
    <v-toolbar color="primary" class="text-white rounded-0" height="80px">
      <v-toolbar-title class="ml-3">
        <h2>Kampanya Raporu</h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :hide-details="true"
            v-model="dateRangeText"
            style="width: 100%; max-width: 220px"
            label="Tarih Aralığı"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            dark
            range
          ></v-text-field>
        </template>
        <v-date-picker v-model="rangeDates" range>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(date)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      <KTTopMenu />
    </v-toolbar>
    <div class="d-flex align-items-center pt-4 px-4">
      <v-select
        v-model="filter_status"
        :items="
          statusOptions.map((s) => ({
            text: s.name,
            value: s,
          }))
        "
        label="Durum Filtrele"
        multiple
        dense
        solo
        chips
        prepend-icon="mdi-filter"
        style="max-width: 100%"
      />
    </div>
    <v-data-table
      :headers="headers"
      :items="reportData"
      :loading="loading"
      :multi-sort="true"
      :items-per-page="100"
      item-key="id"
    >
      <template #item.campaign_name="{ item }">
        <span>{{ item.campaign_name }}</span>
      </template>
      <template #item.campaign_status="{ item }">
        <span>{{ item.campaign_status }}</span>
      </template>
      <template #item.total_lead="{ item }">
        <span>{{ item.total_lead }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import AxiosInstance from "@/core/services/axios.service";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import moment from "moment";

export default {
  name: "CampaignReport",
  components: { KTTopMenu },
  data() {
    return {
      reportData: [],
      menu: false,
      loading: false,
      filter_status: [],
      rangeDates: [
        moment().subtract(1, "month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      headers: [
        {
          value: "campaign_name",
          text: "Kampanya Adı",
          align: "left",
        },
        { value: "campaign_status", text: "Durum", align: "left" },
        { value: "total_lead", text: "Lead Sayısı", align: "center" },
      ],
      statusOptions: [
        { id: 1, name: "Yeni" },
        { id: 2, name: "Görüşme" },
        { id: 3, name: "Teklif Taslağı Oluşturuldu" },
        { id: 4, name: "E-Posta Doğrulanması Bekleniyor" },
        { id: 5, name: "Teklif Gönderildi" },
        { id: 12, name: "Satılamadı" },
        { id: 6, name: "Atandı" },
        { id: 7, name: "U1" },
        { id: 8, name: "U2" },
        { id: 9, name: "U3" },
        { id: 10, name: "Kayıt Tamamlandı" },
        { id: 11, name: "Kullanıcı Kaydı Tamamlandı" },
        { id: 13, name: "Sunum Yapıldı" },
      ],
    };
  },
  mounted() {
    this.fetchCampaignReport();
  },
  methods: {
    async fetchCampaignReport() {
      this.loading = true;

      const [start_date, end_date] = this.rangeDates;

      try {
        const statusIds = this.filter_status.map((s) => s.id);
        const { data } = await AxiosInstance.get("reports/campaign", {
          params: {
            start_date,
            end_date,
            statuses: statusIds,
          },
        });

        this.reportData = data;
      } catch (error) {
        this.$toast.error(
          "Rapor verisi alınamadı:",
          error?.response?.data || error
        );
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    dateRangeText() {
      return this.rangeDates.join(" -- ");
    },
  },
  watch: {
    rangeDates: {
      handler() {
        if (
          this.rangeDates.length === 2 &&
          this.rangeDates[0] &&
          this.rangeDates[1]
        ) {
          this.fetchCampaignReport();
        }
      },
      deep: true,
    },
    filter_status() {
      this.fetchCampaignReport();
    },
  },
};
</script>

<style scoped></style>
